import _objectSpread from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import headCom from "../headCom";
import nextStep from "@/components/nextStep/nextStep";
export default {
  components: {
    headCom: headCom,
    nextStep: nextStep
  },
  data: function data() {
    return {
      projectInfoDec: {
        bhno: "保函编号",
        bidName: "投标人名称",
        notingNumber: "标段(包)编号",
        notingName: "标段(包)名称",
        // guaranteeFee:"保函费用",
        totalFee: "保函费用",
        issueTime: "出函时间",
        tenderBond: "保证金金额(万元)",
        buyGuaranteeDeadline: "保函购买截止日期",
        tenderIsclosedTime: "投标文件递交截止日期",
        validityOfBids: "投标有效期(天)",
        guaranteeBusiness: "保函类型",
        projectType: "项目类型",
        projectName: "项目名称",
        projectNo: "项目编号",
        projectAddress: "项目所在地",
        createTime: "项目创建时间",
        proSerial: "报建编号",
        tenderNoticeUrl: "招标公告网址"
      },
      // 投标单位字段
      bidderDec: {
        enterpriseName: "企业名称",
        creditCode: "统一社会信用代码",
        userPhone: "注册手机号",
        operatorName: "经办人姓名",
        operatorPhone: "经办人联系电话"
      },
      fileListDec: {
        applyFile: {
          name: "索赔申请书",
          files: []
        },
        tenderFile: {
          name: "招标文件",
          files: []
        },
        adviceFile: {
          name: "专家评审意见",
          files: []
        },
        winnerPublicFile: {
          name: "中标公示",
          files: []
        },
        attorneyLetter: {
          name: "经办人授权委托书",
          files: []
        },
        fontIdCard: {
          name: "身份证人像面",
          files: []
        },
        other: {
          name: "其他",
          files: []
        }
      },
      fileList: {
        applyFile: ""
      },
      receiveDec: {
        beneficiaryBankname: "收款开户账户名称",
        claimMoney: "理赔金额(万元)",
        beneficiaryBankacco: "收款开户账号",
        beneficiaryOpenbank: "收款开户行名称",
        beneficiaryOperatorName: "理赔联系人",
        beneficiaryOperatorPhone: "理赔电话",
        claimRemark: "理赔原因"
      },
      handleDec: {
        remark: "处理结果",
        reason: "原因"
      },
      frPath: "",
      pageDetail: {//项目详情
        // remark: "处理后才会显示此项",
      },
      cliamDetail: {},
      //理赔记录详情
      bidderDetail: {},
      //投标企业的信息
      cliamProcess: null,
      showBottom: false
    };
  },
  computed: {
    // 维护期间用于禁用按钮
    isMaintenance: function isMaintenance() {
      return this.userInfo.uptimeController == 1;
    },
    // 判断是担保机构账户
    checkUserType: function checkUserType() {
      return this.userInfo.userType === "2";
    }
  },
  mounted: function mounted() {
    this.frPath = this.$route.query.fr;
    this.requestClime(); // let data = {
    // 	fileUrl: 'hadoop.app.cz:8082/img/eletter/91330782MA2HQTQD9K/a1600151731560/1_image/png' ,
    // };
    // this.publicMethed.downLoadImageC(
    // 	data,
    // 	(res, type) => {
    // 		// this.publicMethed.consolePrint(res)
    // 		this.downFileList= res
    // 	},
    // 	null
    // );
  },
  methods: {
    requestClime: function requestClime() {
      var _this = this;

      var data = {
        claimbidId: this.$route.query.id
      };
      this.requestAPI.selClaimDetail(data).then(function (res) {
        _this.cliamDetail = res.data;
        _this.cliamProcess = res.data.process;

        for (var key in _this.cliamDetail) {
          if (!_this.cliamDetail[key]) {
            _this.cliamDetail[key] = "/";
          }
        }

        if (_this.userInfo.userType == 2 && (_this.userInfo.sonFlag == 0 || _this.userInfo.personnel == 1)) {
          if (_this.cliamDetail.status == '1') {
            _this.showBottom = true;
          }
        }

        _this.requestProject();

        var _loop = function _loop(_key) {
          _this.cliamDetail.file.forEach(function (item, index) {
            if (_key == item.fileMsg) {
              var tem2 = _this.fileListDec[_key];
              var _obj = {};
              _obj.fileTitle = item.fileTitle;
              _obj.fileUrl = item.fileUrl;
              _obj.fileMsg = item.fileMsg;
              tem2.files.push(_obj);

              _this.$set(_this.fileListDec, _key, tem2);
            }
          });
        };

        for (var _key in _this.fileListDec) {
          _loop(_key);
        }
      }); // 获取企业信息(当前理赔投标人的)

      var obj = {
        enterpriseId: this.$route.query.bidId,
        guaranteeId: this.userInfo.enterpriseId
      };
      this.checkUserType && this.requestAPI.selEnterpriseInfoDetail(obj).then(function (res) {
        if (res.errorCode === "0000") {
          _this.bidderDetail = res.data || {};

          _this.$set(_this.bidderDetail, "userPhone", _this.$route.query.rowData.userPhone);
        }
      });
    },
    // 查看上传文件
    viewFileDetil: function viewFileDetil(obj) {
      var _this2 = this;

      // console.log(obj)
      if (obj.bloburl) {
        // 有缓存直接打开/下载
        obj.canDownload && this.publicMethed.saveFileToLocal(obj.bloburl, obj.fileTitle);
        !obj.canDownload && window.open('./showImage.html?img=' + obj.bloburl);
      } else if (obj.fileUrl.indexOf('hadoop') != -1 || obj.fileUrl.indexOf('10.129') != -1) {
        var tem1 = [{
          name: obj.name,
          type: obj.fileMsg,
          file: obj.fileUrl,
          fileUrl: obj.fileUrl
        }];
        this.publicMethed.promiseReFile(tem1, function (res) {
          // this.fileListDec[res.type].file = res.fileShow
          // this.fileListDec[res.type]['fileType'] = res.fileType
          // if (res.fileType == "application/pdf") {
          // 	window.open('./pdf/web/viewer.html?file=' + res.fileShow,
          // 		"_blank")
          // } else {
          // 	window.open('./showImage.html?img=' + res.fileShow)
          // }
          // 图片预览其余都下载，并缓存bloburl地址
          var isImage = res.fileType === 'image/png';

          if (isImage) {
            window.open('./showImage.html?img=' + res.fileShow);
          } else {
            _this2.publicMethed.saveFileToLocal(res.fileShow, obj.fileTitle);
          }

          obj['bloburl'] = res.fileShow;
          obj['canDownload'] = !isImage ? true : false;
          return;
        });
      }
    },
    requestProject: function requestProject() {
      var _this3 = this;

      var data = {
        "notingNumber": this.cliamDetail.notingNumber,
        "channel": this.cliamDetail.channel
      };
      this.requestAPI.SelProjectByNoAndChannel(data).then(function (res) {
        _this3.pageDetail = _objectSpread(_objectSpread({}, res.data), _this3.$route.query.rowData); // this.$set(this.pageDetail, "remark", "处理后才会显示此项");
        // this.$set(this.pageDetail, "guaranteeBusiness", "电子保函");

        _this3.$set(_this3.pageDetail, "projectAddress", _this3.pageDetail.projectProvince + _this3.pageDetail.projectCity + _this3.pageDetail.projectArea);

        if (_this3.pageDetail['projectTypeName']) {
          _this3.$set(_this3.pageDetail, 'projectType', _this3.pageDetail['projectTypeName']);
        } else {
          var tem = _this3.pageDetail['projectType'] == '/' ? '其他' : !window.isNaN(Number(_this3.pageDetail['projectType'])) ? _this3.publicMethed.projectType[Number(_this3.pageDetail['projectType'])] : _this3.pageDetail['projectType'];

          _this3.$set(_this3.pageDetail, 'projectType', tem);
        }

        if (_this3.pageDetail.guaranteeBusiness) {
          var type = _this3.pageDetail.guaranteeBusiness === "1" ? "电子保函" : "纸质保函";

          _this3.$set(_this3.pageDetail, "guaranteeBusiness", type);
        }

        if (_this3.pageDetail.channel != '0000') {
          delete _this3.projectInfoDec['projectAddress'];
        }

        for (var key in _this3.projectInfoDec) {
          if (!_this3.pageDetail[key]) {
            _this3.pageDetail[key] = _this3.cliamDetail[key] || '/';
          }
        }
      });
    },
    backPage: function backPage() {
      this.$router.go(-1);
    },
    // 驳回
    cancel: function cancel(obj) {
      var _this4 = this;

      this.$prompt("请输入处理结果", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "理由不可为空！"
      }).then(function (_ref) {
        var value = _ref.value;
        var data = {
          list: [_this4.cliamDetail.claimbidId],
          status: 1,
          toStatus: 3,
          remark: value
        };

        _this4.requestAPI.updateClaimStatus(data).then(function (res) {
          _this4.showBottom = false;

          _this4.$message({
            type: "success",
            message: "操作成功!"
          });
        });
      });
    },
    // 通过
    handOK: function handOK() {
      var _this5 = this;

      // this.$prompt("请输入处理结果", "提示", {
      // 	confirmButtonText: "确定",
      // 	cancelButtonText: "取消",
      // 	inputPattern: /\S/,
      // 	inputErrorMessage: "理由不可为空！",
      // }).then(({
      // 	value
      // }) => {
      var data = {
        list: [this.cliamDetail.claimbidId],
        status: 1,
        toStatus: 2
      };
      this.requestAPI.updateClaimStatus(data).then(function (res) {
        _this5.showBottom = false;

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });
      }); // });
    }
  }
};